import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { H5, Small } from 'components/Typography';
import { CornerDownRight } from 'lucide-react';

const MyCommentsItem = ({ item, onClick, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const handleClick = () => {
    if (onClick) {
      onClick(item);
    }
  };

  return (
    <>
      <Grid onClick={handleClick} item xs={12} key={item.id} {...props}>
        <Box
          sx={{
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            '&:hover': isMobile
              ? {}
              : {
                  transform: 'translateY(-2px)',
                },
          }}
        >
          {/* First row: Category Tag and Title */}
          <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
            <Box
              sx={{
                backgroundColor: theme.palette.primary.mainBlue,
                color: theme.palette.primary.white,
                padding: '3px 10px',
                borderRadius: '100px',
                fontSize: '12px',
                fontWeight: '600',
                display: 'inline-block',
                flexShrink: 0,
              }}
            >
              {item.category}
            </Box>
            <H5
              sx={{
                fontWeight: 'bold',
                lineHeight: 1.3,
                fontSize: isTablet ? '15px' : '15px',
                color: theme.palette.text.primary,
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 0,
              }}
            >
              {item.title}
            </H5>
          </Box>

          {/* Content Text */}
          <Box mb={2}>
            <Small
              sx={{
                color: theme.palette.primary.greytxt,
                lineHeight: 1.4,
                fontSize: isMobile ? '13px' : '14px',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {item.content}
            </Small>
          </Box>

          {/* Reply Section */}
          <Box display="flex" alignItems="flex-start" gap={1}>
            <CornerDownRight
              size={18}
              color={theme.palette.primary.greytxt}
              style={{ marginTop: '2px', flexShrink: 0 }}
            />
            <Box flex={1}>
              <H5
                sx={{
                  fontWeight: 'bold',
                  lineHeight: 1.3,
                  fontSize: isTablet ? '13px' : '15px',
                  color: theme.palette.text.primary,
                }}
              >
                {item.replyText ||
                  "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 '유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!"}
              </H5>
              <Small
                sx={{
                  color: theme.palette.primary.greytxt,
                  fontSize: isMobile ? '12px' : '13px',
                }}
              >
                {item.replyDate || '2025.10.24'}
              </Small>
            </Box>
          </Box>
        </Box>
      </Grid>

      {/* Horizontal Divider */}
      <Grid item xs={12}>
        <Box
          sx={{
            height: '1px',
            backgroundColor: theme.palette.borderColor,
            margin: '8px 0',
            width: '100%',
          }}
        />
      </Grid>
    </>
  );
};

export default MyCommentsItem;
